import {useRef, useState} from "react";
import {Top, Bottom, Button, Checkbox} from "parts";
import {getUrl, useEmail} from "utils";
import {useTranslation} from "react-i18next";
import {GoalTop} from "../parts";

export function Email({step, toAdd, nextUrl, preload}) {
  const
    {t} = useTranslation('common', {keyPrefix: 'email'})

  const
    formRef = useRef(null),
    [subscribe, setSubscribe] = useState(false)

  if (window.sessionStorage.getItem('summarize'))
    nextUrl = getUrl('/summarize')

  const {
    input,
    handleSubmit,
    handleSubscribe,
    toValidate,
    isLoading
  } = useEmail({
    step, toAdd, nextUrl, subscribe,
    onSubmit: () => {
      handleSubscribe(subscribe)
    }
  })

  return (
    <div className={'wrap fixed'}>
      <style>{
`.animate-move { animation-duration: .5s; will-change: transform,opacity; animation-name: animate-move; animation-timing-function: ease-in-out; transition: background-color .3s,box-shadow .3s }
@keyframes animate-move {
  0%   { opacity: 0; transform: translateX(-150px) }
  100% { opacity: 1; transform: translateY(0) }
}`
      }</style>

      <Top>
        <GoalTop blur={true}/>
      </Top>

      <Bottom className={'fixed'} preload={preload} footer={false}>
        <h2 className={'h4 mt-auto text-center'}>{t('h1')}</h2>

        <form ref={formRef} onSubmit={handleSubmit} className={'w-100 stack gap-5'} style={{position: 'relative'}}>
          <input type={'submit'} className={'d-none'}/>

          {input}

          <Checkbox label={t('subscribe')} checked={subscribe} classNameParent={'note xl'}
                    onChange={(checked) => setSubscribe(checked)}/>

          <div className={'row surface secondary gap-3 rounded-2 animate-move'} style={{padding: 12}}>
            <img src={'/static/img/test/secure.svg'} alt="" width={14} height={16}/>
            <p className={'notice text-start small-sm'}>{t('note')}</p>
          </div>

          <Button type={'submit'}
                  className={!toValidate() ? 'disabled' : ''}
                  onClick={() => toValidate(true)}>
            {t('btn')}
            {isLoading && <span className="spinner ml-2"></span>}
          </Button>
        </form>

        <p className={'mb-1'}/>
      </Bottom>
    </div>
  )
}